import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleAdminSupportAction = createAsyncThunk(
    'get-single-admin-support',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-single-admin-support/${data}?`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleAdminSupportSlice = createSlice({
    name: 'get-single-admin-support',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleAdminSupportAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleAdminSupportAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleAdminSupportAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleAdminSupportReducer = getSingleAdminSupportSlice.reducer